import { useQuery } from '@tanstack/react-query';

import { getNPSCampaignQueryOptions } from '@/api/surveys/getNPSCampaignQuery';

import type { UseGetNPSCampaignQueryOptions } from './types';

export const useGetNPSCampaignQuery = (
  userId: string,
  options?: UseGetNPSCampaignQueryOptions,
) => {
  return useQuery({
    ...getNPSCampaignQueryOptions(userId),
    ...options,
  });
};
